import React from 'react';
import PropTypes from 'prop-types';

const Textarea = ({
  label,
  name,
  placeholder,
  value,
  onChange,
  required = false,
  error,
  rows = 4,
  className = '',
  labelClassName = '',
  textareaClassName = '',
  variant = 'default',
  ...props
}) => {
  const baseClasses = 'w-full px-4 py-2 border focus:outline-none focus:ring-2 transition-colors duration-200';
  
  const variants = {
    default: 'border-gray-300 focus:ring-blue-200 focus:border-blue-500',
    demo: 'px-3.5 py-2.5 bg-white border-[#e9eaec] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] text-[#6a7082] focus:ring-[#2a62aa]',
    feature: 'border-gray-300 focus:ring-[#2a62aa] focus:border-[#2a62aa]',
    privacy: 'border-gray-300 focus:ring-blue-200 focus:border-blue-500'
  };

  const errorClasses = error ? 'border-red-500 focus:ring-red-200' : '';
  const roundedClasses = variant === 'demo' ? 'rounded-lg' : 'rounded';
  
  const textareaClasses = `
    ${baseClasses}
    ${variants[variant]}
    ${errorClasses}
    ${roundedClasses}
    ${textareaClassName}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label 
          htmlFor={name} 
          className={`block text-sm font-medium text-[#121725] mb-1 ${labelClassName}`}
        >
          {label}{required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          rows={rows}
          className={textareaClasses}
          {...props}
        />
      </div>
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
};

Textarea.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  error: PropTypes.string,
  rows: PropTypes.number,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  textareaClassName: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'demo', 'feature', 'privacy'])
};

export default Textarea; 